import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import Button from '@material-ui/core/Button'

import stripeSelectors from 'store/selectors/stripe'
import userActions from 'store/modules/user'

import {
  CURRENCIES,
} from 'settings'

const useStyles = makeStyles(theme => ({
  
}))

const Currency = ({
  
}) => {

  const dispatch = useDispatch()
  
  const currency = useSelector(stripeSelectors.currency)
  const subscriptionCurrency = useSelector(stripeSelectors.subscriptionCurrency)

  const onUpdateCurrency = useCallback((currency) => {
    dispatch(userActions.updateMeta({
      data: {currency},
      snackbar: 'Currency updated',
    }))
  })

  // if we have a subscription currency then we can't change it
  if(subscriptionCurrency) return null
  if(!currency) return null

  return (
    <ButtonGroup size="small" color="default" aria-label="outlined primary button group">
      {
        CURRENCIES.map((currencyItem) => {
          const selected = currencyItem.id == currency.id
          return (
            <Button
              variant={ selected ? 'contained' : 'outlined' }
              color={ selected ? 'primary' : 'default' }
              key={ currencyItem.id }
              onClick={ () => onUpdateCurrency(currencyItem.id) }
            >
              { currencyItem.title }
            </Button>
          )
        })
      }
    </ButtonGroup>
  )
}

export default Currency